import React, { Fragment, isValidElement, cloneElement, createElement } from 'react';
import { useFormContext, get } from 'react-hook-form';
const ErrorMessage = (props) => {
    const { as, errors, name, message, render, ...rest } = props;
    const methods = useFormContext();
    const error = get(errors || methods.formState.errors, name);
    if (!error) {
        return null;
    }
    const { message: messageFromRegister, types } = error;
    const inlineProps = Object.assign({}, rest, {
        children: messageFromRegister || message,
    });
    return isValidElement(as)
        ? cloneElement(as, inlineProps)
        : render
            ? render({
                message: messageFromRegister || message,
                messages: types,
            })
            : createElement(as || Fragment, inlineProps);
};
if (process.env.NODE_ENV !== 'production') {
    ErrorMessage.displayName = 'ErrorMessage';
}
export default ErrorMessage;
//# sourceMappingURL=index.js.map